import { useState } from "react";

export default function ContactSection() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    date: "",
    time: "",
    message: "",
  });
  const [status, setStatus] = useState<"idle" | "submitting" | "success" | "error">("idle");
  const [honeypot, setHoneypot] = useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
  e.preventDefault();

  if (honeypot.trim()) {
    console.log("Bot detected by honeypot");
    return;
  }

  setStatus("submitting");

  try {
    const payload = new FormData();

    payload.append("access_key", "3636cfed-e75d-44d4-bcfc-bdd3bfdc35d0");
    payload.append("subject", "New Consultation Request from Castillo Painting Website");
    payload.append("from_name", "Castillo Painting Website");

    Object.entries(formData).forEach(([key, value]) => {
      payload.append(key, value);
    });

    const res = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: payload,
    });

    const data = await res.json();

    console.log("Web3Forms response:", data);

    if (data.success) {
      setStatus("success");

      setFormData({
        name: "",
        email: "",
        phone: "",
        date: "",
        time: "",
        message: "",
      });
    } else {
      console.error("Web3Forms error:", data);
      setStatus("error");
    }
  } catch (error) {
    console.error("Form submission error:", error);
    setStatus("error");
  }
};

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  return (
    <section id="contact" className="py-16 md:py-24 px-4 md:px-8 lg:px-12 bg-foreground-950">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16">
          <div>
            <div className="inline-flex items-center border border-background-300/30 rounded-full px-5 py-1.5 text-xs font-medium tracking-wider uppercase text-background-300 mb-6">
              Contact Us
            </div>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-medium text-background-50 mb-6">
              Schedule a Consultation
            </h2>
            <p className="text-background-300 mb-8 leading-relaxed">
              Ready to transform your space? Book a free consultation with our team
              and get expert advice on your next painting project.
            </p>

            <div className="space-y-5">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-full bg-primary-500/20 flex items-center justify-center shrink-0">
                  <i className="ri-phone-line text-primary-400"></i>
                </div>
                <div>
                  <p className="text-sm font-medium text-background-50">Phone</p>
                  <a href="tel:9514792556" className="text-sm text-background-300 hover:text-primary-400 transition-colors">
                    (951) 479-2556
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-full bg-primary-500/20 flex items-center justify-center shrink-0">
                  <i className="ri-map-pin-line text-primary-400"></i>
                </div>
                <div>
                  <p className="text-sm font-medium text-background-50">Location</p>
                  <p className="text-sm text-background-300">Corona, CA</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-full bg-primary-500/20 flex items-center justify-center shrink-0">
                  <i className="ri-shield-check-line text-primary-400"></i>
                </div>
                <div>
                  <p className="text-sm font-medium text-background-50">License</p>
                  <p className="text-sm text-background-300">#1150059</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-full bg-primary-500/20 flex items-center justify-center shrink-0">
                  <i className="ri-instagram-line text-primary-400"></i>
                </div>
                <div>
                  <p className="text-sm font-medium text-background-50">Instagram</p>
                  <a href="https://instagram.com/castillo_painting_inc" target="_blank" rel="noopener noreferrer" className="text-sm text-background-300 hover:text-primary-400 transition-colors">
                    @castillo_painting_inc
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-full bg-primary-500/20 flex items-center justify-center shrink-0">
                  <i className="ri-tiktok-line text-primary-400"></i>
                </div>
                <div>
                  <p className="text-sm font-medium text-background-50">TikTok</p>
                  <a href="https://www.tiktok.com/@jcjunkhauling?_r=1&_t=ZP-98CuOyratu3" target="_blank" rel="noopener noreferrer" className="text-sm text-background-300 hover:text-primary-400 transition-colors">
                    @jcjunkhauling
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div>
            <form onSubmit={handleSubmit} className="bg-background-50 rounded-2xl p-6 md:p-8 space-y-5">
              <div style={{ display: "none" }}>
  <input
    type="text"
    name="botcheck"
    value={honeypot}
    onChange={(e) => setHoneypot(e.target.value)}
    tabIndex={-1}
    autoComplete="off"
  />
</div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                <div>
                  <label className="block text-sm font-medium text-foreground-700 mb-1.5">Full Name</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="w-full bg-background-100 border border-background-300 rounded-lg px-4 py-3 text-sm text-foreground-700 placeholder-foreground-400 focus:border-primary-500 focus:ring-1 focus:ring-primary-500 outline-none transition-colors"
                    placeholder="Your name"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-foreground-700 mb-1.5">Email</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full bg-background-100 border border-background-300 rounded-lg px-4 py-3 text-sm text-foreground-700 placeholder-foreground-400 focus:border-primary-500 focus:ring-1 focus:ring-primary-500 outline-none transition-colors"
                    placeholder="your@email.com"
                  />
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-foreground-700 mb-1.5">Phone</label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  className="w-full bg-background-100 border border-background-300 rounded-lg px-4 py-3 text-sm text-foreground-700 placeholder-foreground-400 focus:border-primary-500 focus:ring-1 focus:ring-primary-500 outline-none transition-colors"
                  placeholder="(555) 000-0000"
                />
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                <div>
                  <label className="block text-sm font-medium text-foreground-700 mb-1.5">Preferred Date</label>
                  <input
                    type="date"
                    name="date"
                    value={formData.date}
                    onChange={handleChange}
                    className="w-full bg-background-100 border border-background-300 rounded-lg px-4 py-3 text-sm text-foreground-700 focus:border-primary-500 focus:ring-1 focus:ring-primary-500 outline-none transition-colors"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-foreground-700 mb-1.5">Preferred Time</label>
                  <select
                    name="time"
                    value={formData.time}
                    onChange={handleChange}
                    className="w-full bg-background-100 border border-background-300 rounded-lg px-4 py-3 text-sm text-foreground-700 focus:border-primary-500 focus:ring-1 focus:ring-primary-500 outline-none transition-colors"
                  >
                    <option value="">Select time</option>
                    <option value="morning">Morning (8am - 12pm)</option>
                    <option value="afternoon">Afternoon (12pm - 5pm)</option>
                    <option value="evening">Evening (5pm - 8pm)</option>
                  </select>
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-foreground-700 mb-1.5">Message</label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  maxLength={500}
                  rows={3}
                  className="w-full bg-background-100 border border-background-300 rounded-lg px-4 py-3 text-sm text-foreground-700 placeholder-foreground-400 focus:border-primary-500 focus:ring-1 focus:ring-primary-500 outline-none transition-colors resize-none"
                  placeholder="Any details about your project..."
                ></textarea>
                <p className="text-xs text-foreground-400 mt-1 text-right">{formData.message.length}/500</p>
              </div>
              <button
                type="submit"
                disabled={status === "submitting"}
                className="w-full bg-primary-500 text-background-50 py-3.5 rounded-full text-sm font-medium tracking-wider uppercase hover:bg-primary-600 transition-colors disabled:opacity-60 whitespace-nowrap cursor-pointer"
              >
                {status === "submitting" ? "Scheduling..." : "Schedule Consultation"}
              </button>
              {status === "success" && (
                <p className="text-sm text-primary-600 text-center">Thank you! We will confirm your consultation shortly.</p>
              )}
              {status === "error" && (
                <p className="text-sm text-red-600 text-center">Something went wrong. Please try again.</p>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
